import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PDFViewer = (props) => {
    // Create instances of the plugins
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const toolbarPluginInstance = toolbarPlugin();

    if (!props.path) {
        return <div>Error: No PDF path provided.</div>;
    }

    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <div
                style={{
                    border: '1px solid rgba(0, 0, 0, 0.3)',
                    height: '90vh'
                }}
            >
                <Viewer
                    fileUrl={props.path}
                    plugins={[defaultLayoutPluginInstance, toolbarPluginInstance]}
                />
            </div>
        </Worker>
    );
};

export default PDFViewer;
